module.exports = __webpack_public_path__ + "assets/svg/Icons/32/location-blue-477144.svg";